module.exports = __webpack_public_path__ + "img/avast.7f47dd40.png";